import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import serviceTypesReducer from '../features/serviceTypes/serviceTypesSlice';
import postalCodeReducer from '../features/postalCode/postalCodeSlice';
import addOnsReducer from '../features/addOns/addOnsSlice';
import
serviceLocationReducer
  from '../features/serviceLocation/serviceLocationSlice';
import carReducer from '../features/car/carSlice';
import authReducer from '../features/auth/authSlice';
import bookingReducer from '../features/booking/bookingSlice';
import workOrderReducer from '../features/workOrder/workOrderSlice';
import invoiceReducer from '../features/invoice/invoiceSlice';
import customerReducer from '../features/customer/customerSlice';
import franchiseReducer from '../features/franchise/franchiseSlice';
import payoutReportReducer from '../features/payoutReport/payoutReportSlice';
import tenantReducer from '../features/tenant/tenantSlice';
import consumerReducer from '../consumer/consumerSlice';
import { servicesAnalyticsListener } from './servicesAnalyticsListener';
import { identityAnalyticsListener } from './identityAnalyticsListener';

import { loadState } from './localStorage';

export const store = configureStore({
  reducer: {
    serviceTypes: serviceTypesReducer,
    postalCode: postalCodeReducer,
    addOns: addOnsReducer,
    serviceLocation: serviceLocationReducer,
    car: carReducer,
    auth: authReducer,
    booking: bookingReducer,
    workOrder: workOrderReducer,
    invoice: invoiceReducer,
    customer: customerReducer,
    franchise: franchiseReducer,
    payoutReport: payoutReportReducer,
    tenant: tenantReducer,
    // The consumer skin's own answers (Aperio only; empty elsewhere).
    consumer: consumerReducer,
  },
  preloadedState: loadState(),
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: ['seviceLocation/setNewServiceAddress'],
      ignoredActionPaths: [
        'payload.geometry.location',
        'payload.geometry.viewport',
      ],

      ignoredPaths: [
        'serviceLocation.newServiceAddress',
        'serviceLocation.newServiceAddress.geometry.location',
        'serviceLocation.newServiceAddress.geometry.viewport',
      ],
    },
  })
    .prepend(servicesAnalyticsListener.middleware)
    .prepend(identityAnalyticsListener.middleware),
});
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
